import React from "react";
import { Field } from "redux-form";
import emailMisspelled, { top100 } from "email-misspelled";
import FormField from "./form-field";
import { emailValidate, requiredValidate } from "../../forms/helpers";

const checker = emailMisspelled({ domains: top100 });

const typoValidate = (value) => {
  if (!value) return undefined;
  const matches = checker(value);
  if (matches.length === 0) return undefined;
  return `Please check your email — did you mean ${matches[0].corrected}?`;
};

const EmailField = ({
  name = "email",
  label = "Email",
  required = true,
  placeholder = "",
  ...rest
}) => {
  const validators = required
    ? [requiredValidate, emailValidate, typoValidate]
    : [emailValidate, typoValidate];

  return (
    <Field
      {...rest}
      name={name}
      type="text"
      component={FormField}
      label={required ? `${label}*` : label}
      placeholder={placeholder}
      validate={validators}
    />
  );
};

export default EmailField;
